import React from 'react';
import styled, { css } from 'react-emotion';
import posed from 'react-pose';
import { ReactComponent as Carrot } from '../svg/Carrot.svg';
import { ReactComponent as Check } from '../svg/Check.svg';
export const SelectContainer = styled('div') `
  width: 100%;
  position: relative;
  background-color: #ffffff;
  margin-bottom: 16px;
`;
export const ListItem = styled('button') `
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #dedede;
  position: relative;
  cursor: pointer;
  ${({ disabled }) => disabled &&
    css `
      color: #c2c2c2;
      cursor: not-allowed;
      :hover {
        background-color: #ffffff;
      }
    `};
`;
export const SelectableListItem = styled(ListItem) `
  cursor: pointer;
  border-width: 1px 0 0 0;
  img {
    margin-right: ${({ theme }) => theme.space[2]};
  }
  :last-of-type {
    border-bottom: none;
  }
  :hover {
    background-color: #f2f2f2;
  }
  ${({ selected, isHighlighted }) => (selected || isHighlighted) &&
    css `
      background-color: #f2f2f2;
    `};
  ${({ disabled }) => disabled &&
    css `
      color: #c2c2c2;
      cursor: not-allowed;
      :hover {
        background-color: #ffffff;
      }
    `};
`;
export const ListTitle = styled('h4') `
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  margin-left: ${({ theme }) => theme.space[2]};
  padding-right: ${({ theme }) => theme.space[2]};
`;
export const SelectItem = styled('span') `
  font-size: ${({ theme }) => theme.fontSizes[1]};
  margin-left: ${({ theme }) => theme.space[2]};
  display: block;
`;
export const SelectItemWrapper = styled('span') `
  display: flex;
  flex-direction: row;
`;
const config = {
    enter: {
        height: 'auto'
    },
    exit: {
        height: 0
    }
};
const Transition = posed.div(config);
export const Wrapper = styled(Transition) `
  position: absolute;
  height: 0px;
  z-index: 40;
  width: 100%;
  overflow: hidden;
`;
const InnerWrapper = styled('div') `
  border: 1px solid #dedede;
  border-top: 0;
  overflow-y: auto;
  max-height: 470px;
  ${({ theme }) => theme.below.sm} {
    max-height: 100vh;
  }
  > button:first-child {
    border-top: 0;
  }
`;
export const DropdownWrapper = ({ isOpen, children }) => (React.createElement(Wrapper, { pose: isOpen ? 'enter' : 'exit' },
    React.createElement(InnerWrapper, null, children)));
export const StyledCarrot = styled(Carrot) `
  margin-right: ${({ theme }) => theme.space[2]};
  transition: transform 200ms;
  transform: rotate(-90deg);
  ${({ open }) => open && 'transform: rotate(0deg);'};
`;
export const StyledCheck = styled(Check) `
  margin-right: ${({ theme }) => theme.space[2]};
`;
//# sourceMappingURL=Components.js.map